import { render, staticRenderFns } from "./productType.vue?vue&type=template&id=2634acd8&scoped=true"
import script from "./productType.vue?vue&type=script&lang=js"
export * from "./productType.vue?vue&type=script&lang=js"
import style0 from "./productType.vue?vue&type=style&index=0&id=2634acd8&prod&scoped=true&lang=less"
import style1 from "./productType.vue?vue&type=style&index=1&id=2634acd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634acd8",
  null
  
)

export default component.exports